import {Workday} from '@lib/store/src/data/timeslots/apiTypes';
import {WorkdayTileHeader} from './WorkdayTileHeader';
import {WorkdayContent} from './WorkdayContent';
import {NoWorkdayContent} from './NoWorkdayContent';
import {dateKeyForDateTimeString} from '@lib/store/src/data/timeslots/dateTimeHelpers';

interface WorkdayTileProps {
  workday?: Workday;
  selectedDate: string;
}

export const WorkdayTile = ({workday, selectedDate}: WorkdayTileProps) => {
  const isWorkdaySet = workday !== undefined;

  const dateKey = dateKeyForDateTimeString(selectedDate);

  return (
    <div className="p-4 rounded-xl border border-gray-200 bg-beige-200">
      <WorkdayTileHeader
        workday={workday}
        selectedDate={selectedDate}
      />

      {/* No workday selected yet */}
      {!isWorkdaySet ? <NoWorkdayContent selectedDate={dateKey} /> : null}

      <WorkdayContent
        workday={workday}
        selectedDate={selectedDate}
      />
    </div>
  );
};
